export default "__VITE_ASSET__DAVJATOt__"